import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'

type Props = {
  onAdd: () => void
}

export const OffersHeader = ({ onAdd }: Props) => {
  const { t } = useLocales()

  return (
    <Flex justify="flex-end">
      <Button onClick={onAdd} icon={<Add size={16} />} type="primary">
        {t('offers.generate_offer')}
      </Button>
    </Flex>
  )
}
